
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
import axios from 'axios';
import api from '@/api/';
import store from "@/store/store";
import {commonLocalStorage, getDataSetMap, getSaasParamKeysData} from "@/utils/common";
// 设置浏览器标题
export const setTitle = (title) => {
  if (title) {
    document.title = title
  }
}

// 设置浏览器 favicon
export const setFavicon = (iconUrl) => {
  if (!iconUrl) return
  let link =
    document.querySelector("link[rel='icon']") ||
    document.querySelector("link[rel='shortcut icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.type = 'image/x-icon'
  link.href = iconUrl
}

// 获取配置数据
export const fetchSiteConfig = (type) => {
  return new Promise((resolve) => {
    let url = type === 'yms' ? api.get_ymsMerchant_loadConfig : api.get_ymsCommonConfig_loadConfig;
    axios.get(url, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000514')}).then(response => {
      if (response.data.code === 0) {
        resolve(response.data.datas)
      }
    })
  })
}

// 获取系统语种的可选值
export const fetchLangOptions = () => {
  let languagesList = [];
  let list = commonLocalStorage.getItem('pageConfig')?.languagesList || [];
  let languageEnumMap = commonLocalStorage.getItem('pageConfig')?.languageEnumMap || {};
  return new Promise((resolve) => {
    getSaasParamKeysData().then((obj) => {
      try {
        if (Object.keys(obj).length > 0) {
          let {languageSetSaas = []} = obj;
          languagesList = languageSetSaas.map(ele => ({
            code: ele.value,
            name: ele.code,
            title: languageEnumMap[`${ele.code}`]?.name || '',
            defaultLanguage: list.find(k => k.code === ele.value)?.defaultLanguage,
            iconPath: ele.iconPath
          }));
          commonLocalStorage.setItem('configureLanguage', languagesList)
          store.commit('configureLanguage', languagesList);
        }
      } catch (e) {
        console.error('fetchLangOptions error:', e);
      }
      resolve(languagesList);
    }).catch((e) => {
      console.error('fetchLangOptions request error:', e);
      resolve(languagesList);
    });
  })
}


// 获取各个系统的logo、ico、语种信息
export const fetchSystemInfo = async (type, paramKeys) => {
  const info = {};
  const fetchConfigData = async (query) => {
    const res = await axios.post(api.post_erpCommonSettingParam_api_queryByUK, query, {
      loading: true,
      loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000514'),
      noToken: true
    });
    return res?.data?.code === 0 ? res.data.datas || [] : [];
  };
  const parseConfig = (data, languageEnumMap) => {
    if (data && data.length > 0) {
      data.forEach(item => {
        if (!item.paramValue) return;
        let obj;
        try {
          obj = JSON.parse(item.paramValue);
        } catch (e) {
          console.warn(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001858'), item);
          return;
        }
        // 语种配置
        if (item.paramKey.includes('Language')) {
          info.languagesList = (obj || []).map(ele => ({
            code: ele.value,
            name: ele.code,
            title: languageEnumMap[`${ele.code}`].name || '',
            defaultLanguage: type === 'yms' ? true : !!ele.defaultLanguage,
            iconPath: ele.iconPath
          }));
        }
        // Logo / Ico 配置
        if (item.paramKey.includes('LogoConfig')) {
          info.logoImg = obj.logoImg;
          info.icoImg = obj.icoImg;
        }
      });
    }
  };
  const query = {paramKeys};
  const data = await fetchConfigData(query);
  const languageEnumMap = await getDataSetMap('LanguageEnum')
  parseConfig(data, languageEnumMap);
  info.languageEnumMap = languageEnumMap;
  return info;
};

// 初始化获取当前页面配置
export const initPageConfig = async (type, paramKeys) => {
  try {
    const pageData = await fetchSiteConfig(type);
    const info = await fetchSystemInfo(type, paramKeys);
    let languagesList = info?.languagesList || []
    let obj = {
      sname: pageData?.sname || null, // 系统名称
      scode: pageData?.scode || null, // 系统编码
      systemEnvironment: pageData?.systemEnvironment || null, // 系统环境
      systemBottomFiling: pageData?.systemBottomFiling || null, // 底部备案信息
      domainFilingCode: pageData?.domainFilingCode || null, // 域名备案信息
      mobile: pageData?.mobile || null, // 手机号
      email: pageData?.email || null, // 邮箱
      phone: pageData?.phone || null, // 固定电话
      logoImg: info?.logoImg || null, // 系统logo
      icoImg: info?.icoImg || null, // 系统标签页的ico
      ymsCoreDomain: pageData?.ymsCoreDomain || null, // 运营域名
      distributorDomain: pageData?.distributorDomain || null, // 分销商域名
      supplierDomain: pageData?.supplierDomain || null, // 供应商域名
      languagesList: languagesList,
      languageEnumMap: info?.languageEnumMap || {}
    }
    commonLocalStorage.setItem('pageConfig', obj)
    store.commit('pageConfig', obj)
    if (type !== 'yms') {
      commonLocalStorage.setItem('configureLanguage', languagesList)
      store.commit('configureLanguage', languagesList);
    }
    setFavicon(obj.icoImg);
    setTitle(obj.sname);
    return true
  } catch (e) {
    console.error('[pageConfig] init failed:', e)
    return false
  }
}




















